var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 162 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(105.46 2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 56,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(105.46 2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.54,
    y: 0.5,
    width: 55,
    height: 39.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(105.46 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.54,28a2,2,0,0,1-2-2V4.5a2,2,0,0,1,2-2h43a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2H33.15l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42L22.93,28Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 105.46,
    y: 2.5,
    width: 56,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAoCAYAAACrUDmFAAAACXBIWXMAAAsSAAALEgHS3X78AAACKUlEQVRoQ+2a7W6jMBBFjxu2+/5v220Csz/MDdcOVEAXyWy50gjCV3zmThxlnBQRLCmllBZPNqT4AiLpXAWTxiiupS3VUOHHBJ0iwuEE9mb7rYHVCovB9omI6OxCgb0BtzEctEU52AD0YwiUOcBfY3SUkC1KcD3wAO52vAAU3I0M9z6GIFsHfACf1bFIKb04eCNDvQO/ybAtOwjZvdu4724mINxBd7FjKtWWAYM8PphAi/F2CzOoR+slmsjOzc78opdq2JZnUCjHVo81wSvgWVWbsOjgf6cL8Oy6AM+uC/DsugDPrgvw7LoAz64fBzjXQF3uDLejxR6p92TCtt6K+84P3rX37k3iYk9U6iIirKld9xfl8NqButZ0BaKKrQqmJpPGXDxLDrpj6i8mpqbOFkCH8p5ODaqMDxZbQb1teGcGsi7RnglON+4BVMOqIz+no/y8a2DK/oMScq38OXcmyAEoWvd+oV6rRPcCehMZSkjPukKQWwE1Vi/VRQcH2+8py2otpAPqzSQ1aJXxT+DPuN0KGLadK3WgBMROavZcC+VywHqwSmBPhvogA+51UIoqnuqAaS0tT6d+0R5AyIADpYIpoQJUqLTqe9aqgPIF0cLBmZXSzdkck1SXJkyTDUyAck7ufblau0d1iX5b4/eqKkGTCbwukgjsmYx/DQcHAJqWJi0/t+erYZPSAUkDmFsWrz/PxaRwhHtwICAw9y8Nd/Cpo+DgYMAW9BeEvx6J9sd8bgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-103.46,28a2,2,0,0,1-2-2V4.5a2,2,0,0,1,2-2h43a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2H-76.85l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42L-87.07,28Z",
    transform: "translate(105.46 2.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 105,
    width: 57,
    height: 41.04
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(121.47 20.65)"
  }, "Links")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipLink);
export default __webpack_public_path__ + "static/media/tooltip_link.c6495e7840b76fbdf3996d959602cbbd.svg";
export { ForwardRef as ReactComponent };